module.exports = __webpack_public_path__ + "static/media/bancopel.6b1cf6bb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/logos/bancopel.svg
// module id = 652
// module chunks = 0